// Delay a promise by a given time
export const delayPromise = (time: number, value?: unknown) =>
	new Promise((resolve) => setTimeout(resolve, time, value));

// Delay a promise by a short time (between 50ms and 250ms), to not block the UI
export const spreadPromiseShortDelay = (value?: unknown) =>
	delayPromise(Math.floor(Math.random() * 200 + 50), value);
